import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import useOnClickOutside from "use-onclickoutside";
import {useToasts} from "react-toast-notifications";

import * as actionTypes from "../../store/actions/actionTypes";
import {sendBookingSms} from "../../store/actions/bookingList";

const TYPE_SMS_DEFAULT = 'TYPE_SMS_DEFAULT';
const TYPE_SMS_CUSTOM = 'TYPE_SMS_CUSTOM';

const ModalBookingSms = () => {
    const {addToast} = useToasts();
    const dispatch = useDispatch();
    const {show, booking, preview} = useSelector(state => state.modal.bookingSms);
    const {smsSendingIds} = useSelector(state => state.bookingList);
    const {devSmsTarget_enable, devSmsTarget_phone} = useSelector(state => state.auth);

    const [type, setType] = useState(TYPE_SMS_DEFAULT);
    const [customMessage, setCustomMessage] = useState('');

    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    useEffect(() => {
        if (show) {
            setType(TYPE_SMS_DEFAULT);
            setCustomMessage(preview || '');
        }
    }, [show, preview]);

    const hideModal = () => dispatch({type: actionTypes.MODAL_BOOKING_SMS_HIDE});

    const isSending = booking?.id && smsSendingIds.indexOf(booking.id) > -1;

    const doSend = () => {
        if (isSending) return;
        dispatch(sendBookingSms(booking, type, type === TYPE_SMS_CUSTOM ? customMessage : '', addToast));
    }

    const renderPhone = () => {
        if (devSmsTarget_enable) {
            return <dd><strike>{booking.phone}</strike> <span className="badge badge-danger">DEV TARGET ENABLED = {devSmsTarget_phone}</span></dd>;
        }
        return <dd>{booking.phone || <span className="text-danger">empty</span>}</dd>;
    }

    const renderModal = () => (
        <div className="modal-dialog" role="document" ref={ref}>
            <div className="modal-content modal-content-fit">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                    <span aria-hidden="true">×</span>
                </button>
                <div className="modal-body">
                    <h3>Send SMS to {booking.firstName} {booking.surname}</h3>
                    <dl className="person-list mb-3">
                        <dt>Surgeon</dt>
                        <dd>{booking.surgeon}</dd>
                        <dt>Mobile</dt>
                        {renderPhone()}
                    </dl>
                    <form action="#" className="person-info-form">
                        <div className="form-group mb-3">
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" id="bookingSms_default" value={TYPE_SMS_DEFAULT}
                                       checked={type === TYPE_SMS_DEFAULT} onChange={() => setType(TYPE_SMS_DEFAULT)} />
                                <label className="form-check-label" htmlFor="bookingSms_default">Default</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" id="bookingSms_custom" value={TYPE_SMS_CUSTOM}
                                       checked={type === TYPE_SMS_CUSTOM} onChange={() => setType(TYPE_SMS_CUSTOM)} />
                                <label className="form-check-label" htmlFor="bookingSms_custom">Custom</label>
                            </div>
                        </div>
                        <div className="form-group mb-4">
                            Message <br />
                            {type === TYPE_SMS_DEFAULT
                                ? <textarea className="form-control" disabled value={preview} cols="30" rows="5" readOnly/>
                                : <textarea className="form-control" cols="30" rows="5" value={customMessage} onChange={(e) => setCustomMessage(e.target.value)}/>
                            }
                        </div>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-12 d-flex justify-content-end">
                                    <input type="button" value={isSending ? 'Sending…' : 'Send SMS'} disabled={isSending} className="btn btn-primary" onClick={doSend}/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );

    return (
        <div className={`modal fade ${show ? 'show' : ''}`} id="bookingSmsModal" tabIndex="-1" role="dialog" aria-modal="true">
            {show && renderModal()}
        </div>
    );
}

export default ModalBookingSms;
